module.exports = __webpack_public_path__ + "media/note_settlement.93b3411c.mp3";